import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6b24b48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 fs-7 mt-5 border-bottom" }
const _hoisted_8 = { class: "w-max-content col-lg-3 mb-2" }
const _hoisted_9 = { class: "col-lg-9 row" }
const _hoisted_10 = {
  key: 0,
  class: "col-lg-6"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "me-3" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 fs-7 mt-5 border-bottom" }
const _hoisted_18 = { class: "w-max-content col-lg-3 mb-2" }
const _hoisted_19 = { class: "col-lg-9 row" }
const _hoisted_20 = {
  key: 0,
  class: "col-lg-6"
}
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "me-3" }
const _hoisted_23 = {
  key: 1,
  class: "col-lg-6"
}
const _hoisted_24 = { class: "col-lg-6" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_27 = { class: "w-max-content col-lg-3 mb-2" }
const _hoisted_28 = { class: "col-lg-9 row" }
const _hoisted_29 = { class: "col-lg-6" }
const _hoisted_30 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_31 = { class: "w-max-content col-lg-3 mb-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = {
  key: 0,
  class: "col-lg-9"
}
const _hoisted_34 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_35 = { class: "ms-5" }
const _hoisted_36 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_37 = { class: "ms-5" }
const _hoisted_38 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_39 = { class: "w-max-content col-lg-3 mb-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = { class: "col-lg-9 row" }
const _hoisted_42 = { class: "col-lg-6" }
const _hoisted_43 = { class: "col-lg-6" }
const _hoisted_44 = ["href"]
const _hoisted_45 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 fs-7 border-bottom" }
const _hoisted_46 = { class: "w-max-content col-lg-3 mb-2" }
const _hoisted_47 = { class: "col-lg-9 row" }
const _hoisted_48 = { class: "col-lg-6" }
const _hoisted_49 = { class: "col-lg-6" }
const _hoisted_50 = ["href"]
const _hoisted_51 = { class: "row mx-0 px-0 pb-4 gx-3 mb-5 fs-7" }
const _hoisted_52 = { class: "w-max-content col-lg-3 mb-2" }
const _hoisted_53 = { class: "col-lg-9 row" }
const _hoisted_54 = { class: "col-lg-6" }
const _hoisted_55 = {
  key: 0,
  class: "me-3"
}
const _hoisted_56 = {
  key: 1,
  class: "me-3"
}
const _hoisted_57 = { class: "text-break" }
const _hoisted_58 = { class: "col-lg-6 text-decoration-underline" }
const _hoisted_59 = {
  class: "modal fade",
  id: "modalConfirm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_60 = { class: "modal-dialog modal-lg" }
const _hoisted_61 = { class: "modal-content" }
const _hoisted_62 = { class: "modal-header" }
const _hoisted_63 = { class: "modal-title text-center w-100 fw-bold" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_65 = { class: "modal-body content p-0" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-4 mt-4" }, null, -1))
const _hoisted_67 = { class: "d-flex mx-4" }
const _hoisted_68 = { class: "d-flex align-items-center ms-3" }
const _hoisted_69 = { class: "table-responsive mx-4" }
const _hoisted_70 = { class: "table table-borderless w-max-content" }
const _hoisted_71 = { class: "align-middle text-center" }
const _hoisted_72 = { class: "rounded-top" }
const _hoisted_73 = { class: "rounded-top" }
const _hoisted_74 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { key: 2 }
const _hoisted_78 = { key: 3 }
const _hoisted_79 = { key: 4 }
const _hoisted_80 = {
  key: 5,
  class: "status d-flex justify-content-center fw-bold text-white align-items-center ms-3"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_83 = { key: 3 }
const _hoisted_84 = { key: 4 }
const _hoisted_85 = { key: 5 }
const _hoisted_86 = { class: "d-flex mx-4" }
const _hoisted_87 = { class: "d-flex align-items-center ms-3" }
const _hoisted_88 = { class: "my-4 border-top pt-4 d-flex justify-content-center" }

import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

import Button from '@/components/button/index.vue'
import TagNote from '@/components/tag-note/index.vue'
import PaginationModal from '@/components/pagination/paginationContractHistory.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import FormInquiry from '@/views/user/users/inquiry/form-inquiry/index.vue'

import { translate } from '@/languages/i18n'
import { CONTRACT_INFORMATION_STORE } from '@/store/constants'
import { ConvertYearMonthDay, rangeMonth } from '@/constants/datepicker'
import { DEFAULT_MAIL_TO } from '@/constants/mail'
import { SAAS_TYPE_VALUE } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

dayjs.extend(isSameOrAfter) // 2022/09/28 CW-TrungNT Fix for UAT#4507: CP40 (Ph1-R20220929)

const store = useStore()
const router = useRouter()
const route = useRoute()
const contractInformation = computed(() => store.getters[CONTRACT_INFORMATION_STORE.GETTERS.CONTRACT_INFORMATION]?.contractInformation)
const loading = computed(() => store.getters[CONTRACT_INFORMATION_STORE.GETTERS.CONTRACT_INFORMATION]?.loading)
const curPage = ref(1)

const dataHistory = computed(() => store.getters[CONTRACT_INFORMATION_STORE.GETTERS.CONTRACT_HISTORY])

onMounted(() => {
  store.dispatch(CONTRACT_INFORMATION_STORE.ACTIONS.SET_CONTRACT_INFORMATION, { id: router.currentRoute.value.params?.id })
})
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  // { content: translate('settings'), to: '', active: false },
  {
    content: translate('contractInformation'),
    to: '',
    active: true,
  },
]

const transitCC10 = () => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/managers`)
}

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])
const pageOfNumber = ref(30)

const setContractHistory = () => {
  store.dispatch(CONTRACT_INFORMATION_STORE.ACTIONS.SET_CONTRACT_HISTORY, {
    id: router.currentRoute.value.params?.id,
    params: {
      page: 1,
      page_of_number: 30,
    },
  })
}

const changeQuery = (query: any): void => {
  pageOfNumber.value = query?.page_of_number
  curPage.value = query?.page
  store.dispatch(CONTRACT_INFORMATION_STORE.ACTIONS.SET_CONTRACT_HISTORY, {
    id: router.currentRoute.value.params?.id,
    params: {
      page: query?.page || 1,
      page_of_number: query?.page_of_number || 30,
    },
  })
}
const BackForm = () => {
  pageOfNumber.value = 30
  curPage.value = 1
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('contractInformation')), 1),
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('CP40currentPlan')), 1),
              _createElementVNode("div", _hoisted_9, [
                (_unref(contractInformation)?.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(_unref(SAAS_TYPE_VALUE)[_unref(contractInformation)?.saas_type]), 1),
                        _hoisted_11,
                        _createTextVNode(_toDisplayString(_unref(contractInformation)?.name) + "（" + _toDisplayString(_unref(rangeMonth)(_unref(contractInformation)?.contract_start_date, _unref(contractInformation)?.contract_end_date)) + "ヶ月・" + _toDisplayString(_unref(contractInformation)?.point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')) + " pt）", 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(ConvertYearMonthDay)(_unref(contractInformation)?.contract_start_date)) + " - " + _toDisplayString(_unref(ConvertYearMonthDay)(_unref(contractInformation)?.contract_end_date)), 1),
                        (_unref(dayjs)().isSameOrAfter(_unref(dayjs)(_unref(contractInformation)?.contract_end_date).subtract(90, 'day')) && !_unref(contractInformation)?.next_plan)
                          ? (_openBlock(), _createBlock(TagNote, {
                              key: 0,
                              content: _unref(translate)('CP40noticeRenewDate')
                            }, null, 8, ["content"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: 'mailto:' + _unref(DEFAULT_MAIL_TO) + '?subject=' + _unref(translate)('CP40SubjectPlanUpdate')
                    }, _toDisplayString(_unref(translate)('CP40peopleChange')), 9, _hoisted_15)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: 'mailto:' + _unref(DEFAULT_MAIL_TO) + '?subject=' + _unref(translate)('CP40SubjectServiceCancel')
                    }, _toDisplayString(_unref(translate)('CP40peopleCancel')), 9, _hoisted_16)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('CP40CurrentOption')), 1),
              _createElementVNode("div", _hoisted_19, [
                (_unref(contractInformation)?.community_contract_option)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", null, _toDisplayString(_unref(contractInformation)?.community_contract_option?.option_type), 1),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(ConvertYearMonthDay)(_unref(contractInformation)?.community_contract_option?.start_date)) + " - " + _toDisplayString(_unref(ConvertYearMonthDay)(_unref(contractInformation)?.community_contract_option?.end_date)), 1),
                        (_unref(dayjs)().isSameOrAfter(_unref(dayjs)(_unref(contractInformation)?.community_contract_option?.end_date).subtract(90, 'day')) && !_unref(contractInformation)?.next_option)
                          ? (_openBlock(), _createBlock(TagNote, {
                              key: 0,
                              content: _unref(translate)('CP40OptionContractRenewalMessage')
                            }, null, 8, ["content"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(translate)('CP40OptionContractNotFound')), 1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: 'mailto:' + _unref(DEFAULT_MAIL_TO) + '?subject=' + _unref(translate)('CP40SubjectPlanUpdate')
                    }, _toDisplayString(_unref(translate)('CP40ChangeOption')), 9, _hoisted_25)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(translate)('CP40updateDate')), 1),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(ConvertYearMonthDay)(_unref(contractInformation)?.last_next_plan_end_date)), 1),
                _createElementVNode("div", {
                  class: "btn-toggle-modal col-lg-6",
                  "data-bs-toggle": 'modal',
                  "data-bs-target": '#modalConfirm',
                  onClick: setContractHistory
                }, _toDisplayString(_unref(translate)('CP40contractHistory')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("label", _hoisted_31, [
                _createTextVNode(_toDisplayString(_unref(translate)('community')), 1),
                _hoisted_32,
                _createTextVNode(" " + _toDisplayString(_unref(translate)('CP40maxMembers')), 1)
              ]),
              (_unref(contractInformation)?.members?.maximum)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    (_unref(contractInformation)?.contract_plan_id === 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createTextVNode(_toDisplayString(_unref(translate)('CP40MaxMembersPlan4')) + " ", 1),
                          _createElementVNode("span", _hoisted_35, " (" + _toDisplayString(_unref(translate)('CP40currentMembers')) + ":" + _toDisplayString(_unref(contractInformation)?.members?.current.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + _unref(translate)('name')) + ") ", 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createTextVNode(_toDisplayString(_unref(contractInformation)?.members?.maximum + _unref(translate)('name')) + " ", 1),
                          _createElementVNode("span", _hoisted_37, " (" + _toDisplayString(_unref(translate)('CP40currentMembers')) + ":" + _toDisplayString(_unref(contractInformation)?.members?.current.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + _unref(translate)('name')) + ") ", 1)
                        ])),
                    (
              _unref(contractInformation)?.members?.maximum > 20 &&
              Number(_unref(contractInformation)?.members?.maximum) < 999999999 &&
              _unref(contractInformation)?.members?.current >= Math.floor(_unref(contractInformation)?.members?.maximum * 0.9) &&
              _unref(contractInformation)?.contract_plan_id !== 4
            )
                      ? (_openBlock(), _createBlock(TagNote, {
                          key: 2,
                          content: _unref(translate)('CP40noticeMaxMembers')
                        }, null, 8, ["content"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", _hoisted_39, [
                _createTextVNode(_toDisplayString(_unref(translate)('CP40currentPossession')), 1),
                _hoisted_40,
                _createTextVNode(" " + _toDisplayString(_unref(translate)('CP40yellNumber')), 1)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(contractInformation)?.current_point ? _unref(contractInformation)?.current_point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0) + " pt", 1),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("a", {
                    href: 'mailto:' + _unref(DEFAULT_MAIL_TO) + '?subject=' + _unref(translate)('CP40SubjectBuyPoint')
                  }, _toDisplayString(_unref(translate)('CP40buyPoints')), 9, _hoisted_44)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", _hoisted_46, _toDisplayString(_unref(translate)('CP40contractorInfor')), 1),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", null, _toDisplayString(_unref(contractInformation)?.corporation?.name), 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(contractInformation)?.corporation?.address), 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(contractInformation)?.corporation?.phone), 1)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("a", {
                    href: 'mailto:' + _unref(DEFAULT_MAIL_TO) + '?subject=' + _unref(translate)('CP40SubjectContactChange')
                  }, _toDisplayString(_unref(translate)('CP40peopleConfirm')), 9, _hoisted_50)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("label", _hoisted_52, _toDisplayString(_unref(translate)('CC10contractor')), 1),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", null, [
                    (_unref(contractInformation)?.employee_user?.management_no)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_unref(translate)('managementNo')) + ":" + _toDisplayString(_unref(contractInformation)?.employee_user?.management_no), 1))
                      : _createCommentVNode("", true),
                    (_unref(contractInformation)?.employee_user?.family_name || _unref(contractInformation)?.employee_user?.given_name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_unref(contractInformation)?.employee_user?.family_name + ' ' + _unref(contractInformation)?.employee_user?.given_name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_57, _toDisplayString(_unref(contractInformation)?.employee_user?.email), 1)
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("span", {
                    class: "cursor-pointer",
                    onClick: transitCC10
                  }, _toDisplayString(_unref(translate)('CP40changeContractor')), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_59, [
      _createElementVNode("div", _hoisted_60, [
        _withDirectives(_createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("h5", _hoisted_63, _toDisplayString(_unref(translate)('CP40contractHistory')), 1),
            _hoisted_64
          ]),
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", null, [
                _createVNode(PaginationModal, {
                  totalPage: _unref(dataHistory)?.total_pages || 1,
                  onChangeQuery: changeQuery,
                  isNotFilterUrl: true,
                  pageOfNumber: pageOfNumber.value,
                  curPage: curPage.value
                }, null, 8, ["totalPage", "pageOfNumber", "curPage"])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createVNode(SelectCustom, {
                  options: dataSelectRecordPerPage.value,
                  keyName: 'page_of_number',
                  onChangeQuery: changeQuery,
                  isNotFilterUrl: true,
                  pageOfNumber: pageOfNumber.value
                }, null, 8, ["options", "pageOfNumber"])
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("table", _hoisted_70, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_71, [
                    _createElementVNode("th", _hoisted_72, _toDisplayString(_unref(translate)('CP40contractType')), 1),
                    _createElementVNode("th", null, _toDisplayString(_unref(translate)('CP40contractSaasType')), 1),
                    _createElementVNode("th", null, _toDisplayString(_unref(translate)('CP40contractDetail')), 1),
                    _createElementVNode("th", _hoisted_73, _toDisplayString(_unref(translate)('CP40validityPeriod')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataHistory)?.contractHistory, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: _normalizeClass(["align-middle text-center", { rowEven: index % 2 === 0 }]),
                      key: index
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_74, [
                          (item.contract_type === 'point')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(_unref(translate)('CP40Point')), 1))
                            : (item.plan_type === 'type_new')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_unref(translate)('CP40planNew')), 1))
                              : (item.contract_type === 'option')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(_unref(translate)('CP40ContractTypeOption')), 1))
                                : (item.plan_type === 'type_continue')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(_unref(translate)('CP40planContinue')), 1))
                                  : (item.plan_type === 'type_upgrade')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(_unref(translate)('CP40planUpgrade')), 1))
                                    : _createCommentVNode("", true),
                          (item.status && item.contract_type !== 'point')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(_unref(translate)('CP40underContract')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (item.contract_type === 'point')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_81,
                            _createElementVNode("td", null, _toDisplayString(item?.point?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')) + " pt", 1)
                          ], 64))
                        : (item.contract_type === 'option')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_82,
                              _createElementVNode("td", null, _toDisplayString(item?.option_type), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("td", null, _toDisplayString(_unref(SAAS_TYPE_VALUE)[item?.saas_type]), 1),
                              _createElementVNode("td", null, _toDisplayString(item.name) + "（" + _toDisplayString(_unref(rangeMonth)(item?.contract_start_date, item?.contract_end_date)) + "ヶ月・" + _toDisplayString(item?.point?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')) + " pt） ", 1)
                            ], 64)),
                      (item.contract_type === 'point')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_83, _toDisplayString(_unref(ConvertYearMonthDay)(item?.point_grant_date)), 1))
                        : (item.contract_type === 'option')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_84, _toDisplayString(_unref(ConvertYearMonthDay)(item?.start_date)) + " ～ " + _toDisplayString(_unref(ConvertYearMonthDay)(item?.end_date)), 1))
                          : (_openBlock(), _createElementBlock("td", _hoisted_85, _toDisplayString(_unref(ConvertYearMonthDay)(item?.contract_start_date)) + " ～ " + _toDisplayString(_unref(ConvertYearMonthDay)(item?.contract_end_date)), 1))
                    ], 2))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", null, [
                _createVNode(PaginationModal, {
                  totalPage: _unref(dataHistory)?.total_pages || 1,
                  onChangeQuery: changeQuery,
                  isNotFilterUrl: true,
                  pageOfNumber: pageOfNumber.value,
                  curPage: curPage.value
                }, null, 8, ["totalPage", "pageOfNumber", "curPage"])
              ]),
              _createElementVNode("div", _hoisted_87, [
                _createVNode(SelectCustom, {
                  options: dataSelectRecordPerPage.value,
                  keyName: 'page_of_number',
                  onChangeQuery: changeQuery,
                  isNotFilterUrl: true,
                  pageOfNumber: pageOfNumber.value
                }, null, 8, ["options", "pageOfNumber"])
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createVNode(Button, {
                title: _unref(translate)('close'),
                "data-bs-dismiss": "modal",
                type: 'secondary'
              }, null, 8, ["title"])
            ])
          ])
        ], 512), [
          [_directive_click_outside, BackForm]
        ])
      ])
    ]),
    _createVNode(FormInquiry)
  ], 64))
}
}

})